<template>
  <div class="container base">
    <div class="base__title-container">
      <div class="base__title-left" />
      <div class="base__title-right">
        <!-- <div class="">
          <div
            v-tooltip.bottom-start="{ content: 'Create Group', ...tooltipOptions }"
            class="base__tab"
            @click="openCrudModal"
          >
            <base-material-design-icon
              icon="plusCircle"
              class="urlc__icon"
            />
          </div>
        </div> -->
        <div class="">
          <div
            v-tooltip.bottom-start="{ content: 'Column Editor', ...tooltipOptions }"
            class="base__tab"
            @click="$modal.show('column-editor')"
          >
            <base-material-design-icon
              icon="tableColumnPlusAfter"
              class="base__icon"
            />
          </div>
        </div>
        <base-select
          v-model="pageItemsLimit"
          :options="paginationOptions"
          align-left
          :title-style="{ 'padding-left': '5px' }"
          :header-style="{ backgroundColor: '#ffffff' }"
          show-top-border
          shift-label-right
          :select-style="{ 'margin': '5px', 'height': '34px !important', width: '100px !important' }"
          :prop-list-style="{ cursor: 'pointer' }"
        />
      </div>
    </div>

    <div>
      <div
        id="authorization_permissions_table"
        ref="table"
      />
    </div>
    <div
      v-if="isDataUpdating"
      class="base__update-loader"
    >
      <base-loader class="base__update-loader-ring" />
    </div>

    <modal
      name="crud"
      v-bind="modalProps"
    >
      <PermissionsCrud
        :categories="categoriesSelectList"
        :selected-permission="selectedPermission"
        @close="closeCrudModal"
        @update="triggerUpdatePermission"
      />
    </modal>
    <modal
      name="column-editor"
      v-bind="modalProps"
    >
      <base-tabulator-column-editor
        ref="column-editor"
        :table="tabulator"
        :hidden-columns="['edit-button']"
        @close="$modal.hide('column-editor')"
      />
    </modal>
    <base-material-design-icon
      ref="iconPencil"
      style="font-size:14px;"
      icon="edit"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Tabulator from 'tabulator-tables'
import PermissionsCrud from './PermissionsCrud.vue'
import baseModalProps from '@/common/BaseModalProps'
import BaseSortMixins from '@/common/BaseSortMixins'

const ITEMS_PER_PAGE = 50
const PAGINATION_OPTIONS = [
  {
    label: '10',
    value: 10
  },
  {
    label: '25',
    value: 25
  },
  {
    label: '50',
    value: 50
  }
]
// table config
const DEFAULT_CONFIG = [
  // {
  //   label: '',
  //   property: 'tree-toggle'
  // },
  {
    title: '',
    field: 'edit-button'
  },
  {
    title: 'Name',
    field: 'name',
  },
  {
    title: 'Category',
    field: 'category_id',
  },
  {
    title: 'Resource',
    field: 'resource',
  },
  {
    title: 'Description',
    field: 'description',
  },
]


export default {
  name: 'Permissions',
  components: { PermissionsCrud },
  mixins: [BaseSortMixins],
  data() {
    return {
      tabulator: null,
      isDataFetched: false,
      isHeaderOpened: false,
      selectedPermission: null,
      attachments: [],
      isDataUpdating: false,
      tableColumns: [],
      pageItemsLimit: ITEMS_PER_PAGE,
      paginationOptions: _.cloneDeep(PAGINATION_OPTIONS),
      opts: {},
    }
  },
  computed: {
    ...mapState('authorization', ['permissions', 'groups']),
    ...mapState('category', ['categories']),
    modalProps() {
      const modalProps = {
        width: '75%'
      }
      return { ...baseModalProps, ...modalProps }
    },
    categoriesSelectList() {
      return this.categories.filter(category => {
        return category.is_active && category.fk_pivot_table === 'user_security' && category.fk_pivot_field === 'fk_category_id'
      }).map(category => {
        return {
          label: category.name,
          value: category.id
        }
      })
    }
  },
  watch: {
    categories: {
      handler() {
        this.updateCategoryColumnData(this.categoriesSelectList)
      },
      deep: true
    },
    permissions: {
      handler(newData) {
        this.tabulator.replaceData(newData)
      },
      deep: true
    },
    pageItemsLimit(v) {
      this.tabulator.setPageSize(v)
    },
    clientId: {
      handler(v) {
        v && this.loadData(true)
      },
      immediate: true
    },
  },
  async mounted() {
    const rawIconPencilHtmlString = this.$refs.iconPencil.$el.outerHTML.toString()
    this.$refs.iconPencil.$el.parentNode.removeChild(this.$refs.iconPencil.$el)
    const columns = _.cloneDeep(DEFAULT_CONFIG)
    const handleOpenEdit = (e, cell) => {
      this.openCrudModal(cell.getRow().getData().id)
    }
    const editButtonColumn = columns.find(col => col.field === 'edit-button')
    editButtonColumn.width = '40'
    editButtonColumn.cellClick = handleOpenEdit
    editButtonColumn.formatter = () => {
      return rawIconPencilHtmlString
    }
    editButtonColumn.resizable = false
    editButtonColumn.headerSort = false
    const categoryIdColumn = columns.find(col => col.field === 'category_id')
    categoryIdColumn.formatterParams = this.categoriesSelectList.reduce((prev, curr) => {
      prev[curr.value] = curr.label
      return prev
    }, {})
    categoryIdColumn.formatter = 'lookup'


    // const treeToggleColumn = columns.find(col => col.field === 'tree-toggle')
    // treeToggleColumn.resizable = false
    // treeToggleColumn.headerSort = false
    // treeToggleColumn.maxWidth = '180'

    this.tabulator = new Tabulator(this.$refs.table, {
      data: this.permissions, //link data to table
      dataTree: true,
      dataTreeStartExpanded: true,
      dataTreeElementColumn: 'name',
      reactiveData: true, //enable data reactivity
      columns: columns, //define table columns
      autoResize: true,
      layout: 'fitColumns',
      selectable: false,
      resizableColumns: true,
      movableColumns: false,
      headerSortTristate: true,
      headerSortElement: "<i class='fas fa-caret-up'></i>",
      pagination: 'local',
      paginationSize: this.pageItemsLimit,
      // persistenceID: 'auth_permissions_table',
      // persistenceMode: 'local',
      // persistence: {
      //   columns: ['width', 'visible', 'frozen']
      // },
    })
    this.tableColumns = this.tabulator.getColumns()
  },
  methods: {
    ...mapActions('authorization', ['getPermissionsData', 'getGroupData', 'updatePermission']),
    ...mapActions('category', ['getCategoryData']),
    ...mapActions('users', ['getUsersByClient']),
    updateCategoryColumnData(selectList) {
      this.tabulator?.updateColumnDefinition('category_id', {
        'formatterParams': selectList.reduce((prev, curr) => {
          prev[curr.value] = curr.label
          return prev
        }, {})
      })
    },
    async loadData(fullReload = false) {
      this.isDataUpdating = true
      const requests = [
        this.getPermissionsData({ clientId: this.clientId })
      ]
      if (fullReload) {
        requests.push(
          this.getUsersByClient({ clientId: this.clientId }),
          this.getGroupData({ clientId: this.clientId }),
          this.getCategoryData()
        )
      }
      await Promise.all(requests)
      this.isDataUpdating = false
    },
    async triggerUpdatePermission(permission) {
      this.isDataUpdating = true
      try {
        await this.updatePermission({ clientId: this.clientId, permission })
        this.closeCrudModal()
        await this.loadData()
      } finally {
        this.isDataUpdating = false
      }
    },
    closeCrudModal() {
      this.selectedPermission = null
      this.$modal.hide('crud')
    },
    getNestedRowById(row, permissionId, i = 0) {
      if (i >= row.length) {
        return null
      }
      if (permissionId === row[i].id) {
        return row[i]
      }
      if (row[i]._children?.length) {
        const foundRow = this.getNestedRowById(row[i]._children, permissionId)
        if (foundRow) return foundRow
      }
      return this.getNestedRowById(row, permissionId, i + 1)
    },
    async openCrudModal(permissionId) {
      this.selectedPermission = this.getNestedRowById(this.tabulator.getData(), permissionId)
      this.$modal.show('crud')
    },
  },

}
</script>

<style lang="scss">
#authorization_permissions_table .tabulator-tree-level-1 {
  background-color: #f4f6fb;
}

#authorization_permissions_table .tabulator-tree-level-3 {
  background-color: #f4f6fb;
}

#authorization_permissions_table .tabulator-tree-level-5 {
  background-color: #f4f6fb;
}

#authorization_permissions_table .tabulator-tree-level-7 {
  background-color: #f4f6fb;
}

#authorization_permissions_table .tabulator-tree-level-9 {
  background-color: #f4f6fb;
}
</style>
<style scoped lang="scss">
#add-tab-dropdown {
  height: 20px !important;
  padding: 1px;
  cursor: pointer;
}

.common-table {
  background-color: $rfx-background-color;

  &__with-data {
    min-height: 350px;
    overflow-x: scroll;
  }

  &__row {
    background-color: #fff;
    border-bottom: 1px solid $rfx-light-steel;
    border-left: 1px solid $rfx-light-steel !important;
    border-right: 1px solid $rfx-light-steel !important;
  }

  &::-webkit-scrollbar {
    visibility: hidden;
  }

  &>div {
    &:last-child {
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  }

  &__header {
    border-top-right-radius: 4px;
    border-top-left-radius: 4px;
    background-color: #dbdfe5 !important;

    &_scrollable {
      overflow-x: scroll;
    }
  }

  &__header-cell {
    background-color: #dbdfe5 !important;
    color: $rfx-dark-march;
    font-weight: bold;
    padding: 0;
    height: 60px;
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  &__cell {
    background-color: #fff;
    color: $rfx-dark-march !important;
    height: 60px;
    padding: 0;
    display: flex;
    align-items: center;
    font-size: 12px;
    padding-left: 14px;

    &:first-child {
      padding-left: 25px;
    }

  }

}

.base {
  position: relative;
  min-height: 200vh !important;

  &__wait-columns {
    background: white;
    height: 300px;
    border-bottom: none;
  }

  &__keyword-header {
    background-color: rgba(1, 22, 39, 0.1);
  }

  &__cross {
    font-size: 21px;
    margin-left: 5px;
    margin-top: -2px;
  }

  &__title-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    // flex: 1 1 50%;
    height: 60px;

    &_multi-select {
      align-self: flex-end
    }
  }

  &__title-left {
    display: flex;
    align-items: center;
  }

  &__title-left>*:not(:last-child) {
    margin-right: 30px;
  }

  &__header-button-wrapper {
    border-radius: 15px;
    border: solid 1px $rfx-light-steel;
    background: white;
    height: 28px;
    display: flex;
    padding: 0 10px;
  }

  &__copy-button {
    flex: 1 1 50%;
    height: 100%;
    border: none;
    outline: none;
    color: $rfx-dark-march;
    white-space: nowrap;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 90px;
    background-color: #fff;
    font-size: 11px;

    &:hover {
      opacity: 0.5;
    }
  }

  &__clear-filters {
    @extend .base__copy-button;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: auto;

  }

  &__sortable-column {
    padding-left: 14px;
  }

  &__grid-select {
    flex-basis: 100px;
  }

  &__title-container {
    padding: 14px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__loader {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    height: calc(100vh - 530px);
  }

  &__table {
    position: relative;
    display: flex;
    flex-direction: column;
  }

  &__update-loader {
    position: absolute;
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    background-color: white;
    top: 0;
    opacity: 0.5;
    z-index: 10000;
  }

  &__update-loader-ring {
    margin-top: 200px;
  }


  &__edit-button {
    flex: 0 0 45px;

    &.common-table__header-cell {
      flex: 0;
    }
  }

  &__link_type,
  &__agent,
  &__agent_order_record,
  &__agent_assignment_date,
  &__agent_target_date,
  &__publish_date,
  &__domain_authority,
  &__trust_flow,
  &__citation_flow,
  &__has_featured_image {
    flex: 0 0 180px;

    &.common-table__cell {
      flex-basis: 166px;
    }
  }

  &__link_type,
  &__status,
  &__state,
  &__client_invoice,
  &__client_sow,
  &__agent,
  &__agent_order_record {
    flex: 0 0 130px;

    &.common-table__cell {
      flex-basis: 115px;
    }
  }

  &__tf_ratio {
    flex: 0 0 110px;

    &.common-table__cell {
      flex-basis: 96px;
    }
  }

  &__domain_authority,
  &__trust_flow,
  &__citation_flow {
    flex: 0 0 80px;

    &.common-table__cell {
      flex-basis: 66px;
    }
  }

  &__publisher_url,
  &__target_url {
    flex: 0 0 600px;

    &.common-table__cell {
      flex-basis: 587px;
    }
  }

  &__is_active {
    flex: 0 0 119px;

    &.common-table__header-cell {
      flex-basis: 200px;

      &::v-deep .multi-select__title-container {
        padding-left: 69px !important;
      }
    }
  }

  &__button {
    width: 136px;
    padding: 0 20px;
    height: 60px;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 900;
    text-transform: uppercase;
    border: none;
    outline: none;
    cursor: pointer;
    background-color: $rfx-medium-march;
    color: #fff;
    margin-left: 20px;
  }

  &__count {
    color: #b2b9be;
    font-size: 14px;
    font-weight: 600;
    text-decoration: none;
    width: 75px;
    white-space: nowrap;
  }

  &__tabs {
    display: grid;
    width: 50%;
    margin: 5px 0;
    border: 1px solid $rfx-light-steel;
    border-radius: 4px;
    height: 40px;
    flex: 15%;
    height: 34px;

    &.page-tabs {
      grid-template-columns: 1fr;
    }
  }

  &__tab {
    font-weight: 500;
    outline: none;
    font-size: 10px;
    border: 1px solid $rfx-light-steel;
    color: $rfx-dark-march;
    margin: 0;
    cursor: pointer;
    transition: box-shadow .3s;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    text-decoration: none;
    padding: 5px;

    &:hover {
      /* box-shadow: 0 0 11px 5px rgba(33,33,33,.2); */
      background-color: rgba(1, 22, 39, 0.1);
      opacity: 1;

    }

    &_center {
      border-left: 1px solid $rfx-light-steel;
      border-right: 1px solid $rfx-light-steel;
    }

    &_disabled {
      pointer-events: none;
      cursor: default;
    }

    &_active {
      background-color: rgba(1, 22, 39, 0.1);
      opacity: 1;
    }

    &__enabled {
      color: $rfx-bright-blue
    }
  }
}

.pagination-wrapper {
  display: flex;
  height: 60px;
  margin-top: 10px;
  justify-content: center;
  align-items: center;
  border: 1px solid $rfx-light-steel;
  border-radius: 4px;
}

.no-data-block {
  min-height: 250px;
  border-bottom: 1px solid $rfx-light-steel;
}

.common-table {
  &__header-cell {
    color: $rfx-dark-march;
    font-weight: bold;
  }
}

.edit-icon {
  cursor: pointer;
  font-size: 20px;
  justify-self: end;
  display: grid;
  color: $rfx-dark-march;
}
</style>
